import React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgCheckCircle = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M18.994 10.756a.876.876 0 0 1 0 1.238L12.87 18.12a.876.876 0 0 1-1.238 0l-2.625-2.625a.876.876 0 0 1 1.238-1.238l2.006 2.007 5.506-5.507a.876.876 0 0 1 1.238 0ZM25.375 14A11.375 11.375 0 1 1 14 2.625 11.387 11.387 0 0 1 25.375 14Zm-1.75 0A9.625 9.625 0 1 0 14 23.625 9.636 9.636 0 0 0 23.625 14Z" />
  </svg>
);
export default SvgCheckCircle;
